<template>
  <div class="Work_statistics">
    <el-form :inline="true" class="filter-form" label-width="85px">
      <el-form-item label="姓名：">
        <el-input v-model="filters.name" placeholder="请输入姓名" clearable />
      </el-form-item>
      <el-form-item label="统计时间：">
        <el-date-picker
          style="width: 260px;"
          v-model="dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>
      <el-form-item label-width="20px">
        <el-button type="primary" @click="onSearch">搜索</el-button>
        <el-button @click="onReset">重置</el-button>
        <el-button type="primary" style="margin-bottom: 16px;" @click="onExport" :loading="exoprtloading">导出</el-button>
      </el-form-item>
    </el-form>

    <main>
        <div class="table_title">
          心理中心科普宣传稿费劳务费明细
        </div>
        <el-table :data="tableData" 
        :span-method="objectSpanMethod"
        style="width: 100%;" 
        v-loading="Workloadstatisticsloading">
            <el-table-column prop="realName" label="姓名" align="center" />
            <el-table-column prop="workDate" label="工作日期" align="center" />
            <el-table-column prop="content" label="工作内容" align="center" />
            <el-table-column prop="role" label="工作角色" align="center" />
            <el-table-column prop="quantity" label="数量" align="center" />
            <el-table-column prop="duration" label="工作时长（小时）" align="center" />
            <el-table-column prop="salary" label="劳务费" align="center" />
            <el-table-column prop="subtotal" label="小计" align="center"  width="100"/>
        </el-table>
        <p class="total">
            <label>合计</label>
            <span>{{totalFee}}</span>
        </p>
    </main>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filters: {
        workDetailKey:'',
        name: '',
        status:'2',
        from:'',
        to:'',
        exportFlag:'0',
        mode:0,
        orderBy:'realName'
      },
      exoprtloading:false,
      dateRange: [],
      tableData: [],
      Workloadstatisticsloading:false,
      totalFee:0
    };
  },
  watch:{
    dateRange(newval){
      if(newval==null){
        this.filters.from=''
        this.filters.to=''
      }else{
        this.filters.from=newval[0]
        this.filters.to=newval[1]
      }
    }
  },
  created(){
    this.onSearch()
  },
  methods: {
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 只对小计列进行合并
      if (columnIndex === 7) { // 小计列的索引
        const userID = row.userID;
        const sameUserRows = this.tableData.filter(item => item.userID === userID);
        const firstIndex = this.tableData.findIndex(item => item.userID === userID);
        
        if (rowIndex === firstIndex) {
          return {
            rowspan: sameUserRows.length,
            colspan: 1
          };
        } else {
          return {
            rowspan: 1,
            colspan: 1
          };
        }
      }
    },
    onSearch(){
        this.$Http_Post('/management/getSalaryList',this.filters).then(res=>{
            this.filters.exportFlag=0;
            this.Workloadstatisticsloading=false;
            if(res.Code==200 || res.Code==0){
              this.tableData=res.Data;
              this.totalFee=res.Data.reduce((total,item)=>total+parseInt(item.salary),0);
              
              // 处理小计数据
              this.processSubtotals();
            }else{
                this.$message.error(res.Message)
            }
        })
    },
    processSubtotals() {
      // 按userID分组计算小计
      const userGroups = {};
      
      this.tableData.forEach((item, index) => {
        const userID = item.userID;
        if (!userGroups[userID]) {
          userGroups[userID] = [];
        }
        userGroups[userID].push(index);
      });
      
      // 计算每个用户的小计
      Object.keys(userGroups).forEach(userID => {
        const indices = userGroups[userID];
        const totalSalary = indices.reduce((sum, index) => {
          return sum + (parseInt(this.tableData[index].salary) || 0);
        }, 0);
        
        // 只在第一行显示小计
        this.$set(this.tableData[indices[0]], 'subtotal', totalSalary);
      });
    },
    onReset() {
      this.filters = this.$options.data().filters;
      this.dateRange = [];
      this.onSearch()
    },
    onExport(){
        this.filters.exportFlag=1;
        this.exoprtloading=true;
        this.$Http_Post('/management/getSalaryList',this.filters).then(res=>{
          this.filters.exportFlag=0;
          this.exoprtloading=false;
          if(res.Code==0 || res.Code==200){
            window.open(res.Data);
            this.$message.success(res.Message)
          }else{
            this.$message.error(res.Message)
          }
        })
    }
  },
};
</script>

<style>
.Work_statistics .filter-form {background: #fff;padding: 16px 0 0;margin-bottom: 16px;}
.Work_statistics .table_title{background: #E4EAF2;padding: 15px 0;text-align: center;}
.Work_statistics main{background: #fff;padding: 16px;}
.Work_statistics main .total{display: flex;justify-content:space-between;align-items: center;color: #606266;border: 1px solid #ebeef5;padding:15px 0;}
.Work_statistics main .total label{padding-left: 60px;}
.Work_statistics main .total span{width: 100px;text-align:center;}
.Work_statistics main thead th:first-child{border-left:none;}
</style>